/**
 * @generated SignedSource<<654bc903a598e999c74e0a73caed26bd>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RegularTileContent_nftItem$data = {
  readonly " $fragmentSpreads": FragmentRefs<"NftItemTileAuctionDetails_nftItem" | "NftItemTileItemDetails_nftItem">;
  readonly " $fragmentType": "RegularTileContent_nftItem";
};
export type RegularTileContent_nftItem$key = {
  readonly " $data"?: RegularTileContent_nftItem$data;
  readonly " $fragmentSpreads": FragmentRefs<"RegularTileContent_nftItem">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RegularTileContent_nftItem",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NftItemTileItemDetails_nftItem"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NftItemTileAuctionDetails_nftItem"
    }
  ],
  "type": "NftItem",
  "abstractKey": null
};

(node as any).hash = "c6f23cae9d8aec13c9c5f56dc52b5ecf";

export default node;
